/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author Shihan Rahim
 * 17/10/2022
 *
 */

import React from 'react';
import Loader from "../../../loader/loader";
import FormElementGenerator from "../../form-elements/formElementGenerator";
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";
import axios from "axios";
import API from "../../../../../utils/api";

class CoreLogDataDisplayForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            logTraceId: null,
            logHostName: '',
            logUserName: '',
            logCourseName: '',
            logPartner: '',
            logInstitution: '',
            logCategory: '',
            logLogLevel: '',
            logMsg: '',
            logCreatedDate: '',
            logStack: '',

            isDisplayLoader: true,
            errors: {},

            token: '',
            fields: [
                {
                    inputType: 'text',
                    labelName: 'Id',
                    inputName: 'logTraceId',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'HostName',
                    inputName: 'logHostName',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'User Id',
                    inputName: 'logUserName',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Course Id',
                    inputName: 'logCourseName',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Partner',
                    inputName: 'logPartner',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Institution',
                    inputName: 'logInstitution',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Category',
                    inputName: 'logCategory',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Log Level',
                    inputName: 'logLogLevel',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'textArea',
                    labelName: 'Msg',
                    inputName: 'logMsg',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Created Date',
                    inputName: 'logCreatedDate',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'textArea',
                    labelName: 'Stack',
                    inputName: 'logStack',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                }
            ]
        };

        // set icons to the header
        EventEmitter.emit('setPageHeaderData', {
            page: 'coreLogs',
            pageName: "View Log",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/coreLogs",
            optionalIcons: ['backIcon']
        });
        EventEmitter.on('navigateToPreviousPage', this.navigateToPreviousPage);
    }

    // set a token to unsubscribe the async call
    CancelToken = axios.CancelToken;
    source = this.CancelToken.source();

    componentDidMount = async () => {
        // get parameter from URL
        const logTraceId = this.props.match.params.id;

        // get token
        const user = JSON.parse(localStorage.getItem('tmcUser'));
        const token = 'Bearer ' + user.token;

        const oldState = Object.assign({}, this.state);

        // fill the form if not a create partner
        if (logTraceId !== undefined) {

            const url = '/logs?search=%7BlogTraceId:' + logTraceId + '%7D';

            await API.get(url, {headers: {Authorization: token}, cancelToken: this.source.token})
                .then(res => {
                    const data = res.data[0];
                    oldState.logTraceId = (data.logTraceId !== undefined) ? data.logTraceId : null;
                    oldState.logHostName = (data.logHostName !== undefined) ? data.logHostName : null;
                    oldState.logUserName = (data.logUserName !== undefined) ? data.logUserName : null;
                    oldState.logCourseName = (data.logCourseName !== undefined) ? data.logCourseName : '';
                    oldState.logPartner = (data.logPartner !== undefined) ? data.logPartner : '';
                    oldState.logInstitution = (data.logInstitution !== undefined) ? data.logInstitution : '';
                    oldState.logCategory = (data.logCategory !== undefined) ? data.logCategory : '';
                    oldState.logLogLevel = (data.logLogLevel !== undefined) ? data.logLogLevel : '';
                    oldState.logMsg = (data.logMsg !== undefined) ? data.logMsg : '';
                    oldState.logCreatedDate = (data.logCreatedDate !== undefined) ? data.logCreatedDate : '';

                    oldState.token = token;
                    oldState.isDisplayLoader = false;

                    this.setState(oldState);
                }).catch(er => {
                    oldState.isDisplayLoader = false;
                    this.setState(oldState);

                    if (er.response === undefined) {
                        localStorage.removeItem('tmcUser')
                        this.props.history.push('/');
                    } else {
                        this.setAlert("Error", "Error", "Sorry! Unable to load Log details");
                    }
                });
        } else {
            oldState.token = token;
            oldState.isDisplayLoader = false;
            this.setState(oldState);
        }
    };

    componentWillUnmount = () => {
        // remove all event emitters
        EventEmitter.off('navigateToPreviousPage', this.navigateToPreviousPage);
        this.source.cancel("cancel log async calls");
    };

    /**
     * navigate to previous page
     */
    navigateToPreviousPage = () => {
        this.props.history.push('/home/coreLogs');
    };

    handleChange = event => {
        console.log("Do not delete");
    };

    render() {
        return(
            <div role="form" className="container">
                {this.state.isDisplayLoader && <Loader/>}
                <form>
                    <FormElementGenerator currentState={this.state} handleChange={this.handleChange} />
                </form>
            </div>
        )
    }
}

export default CoreLogDataDisplayForm;
